import { LazyFallback } from "@msuite/ui/loading-screen";
import { Panels } from "@msuite/ui/panels";
import { lazy, Suspense } from "react";
import { useOrder } from "@/hooks/use-order";
import type { OrderPanelBaseProps } from "../../shared";
import { OrderInformation } from "./order-information";

const Notes = lazy(() => import("@/components/notes"));

export function OrderGeneral({ orderId }: OrderPanelBaseProps) {
	/** Query */
	const { order } = useOrder(orderId);

	/** Render */
	return (
		<Panels>
			<Panels.Panel
				flex={1}
				className="bottom-space"
			>
				<OrderInformation orderId={orderId} />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Suspense fallback={<LazyFallback variant="inline" />}>
					<Notes
						notesTable="orderNotes"
						identifier={orderId}
						parent={order}
					/>
				</Suspense>
			</Panels.Panel>
		</Panels>
	);
}
